module.exports = __webpack_public_path__ + "img/green.d86a7963.png";